import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { financecommerceApi, type Settlement } from '../../api/financecommerce';

export function ReconciliationDashboardPage() {
  const [items, setItems] = useState<Settlement[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void financecommerceApi.listSettlements().then(setItems);
  }, []);

  async function reconcile(id: string) {
    await financecommerceApi.reconcileSettlement(id);
    setMsg('Reconciliation complete');
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/finance" className="text-sm text-slate-600 hover:underline">← Finance hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Reconciliation dashboard</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <ul className="mt-4 space-y-2">
        {items.map((s) => (
          <li key={s.id}>
            <button type="button" onClick={() => void reconcile(s.id)}
              className="rounded border px-3 py-2 text-sm">Reconcile {s.settlement_number}</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
